module.exports = __webpack_public_path__ + "static/img/logo.bae002f9.png";